<template>
  <div></div>
</template>
<script>
import { Toast } from 'vant'
import http from '../utils/http'
export default {
  props: {
    code: {
      type: String,
      required: true
    },
    redirect: {
      type: String,
      default: '/'
    }
  },
  created () {
    if (!this.code) {
      return this.$router.replace('/')
    }
    Toast.loading({
      message: '登录中...',
      duration: 0,
      forbidClick: true
    })
    http.post('/token/get', { code: this.code }).then(({ token, auth_key }) => {
      sessionStorage.setItem('token', token)
      sessionStorage.setItem('auth-key', auth_key)
      this.$router.replace(this.redirect)
    }).catch((error) => {
      Toast.fail(error.message)
    })
  }
}
</script>
